import React, { useState, useEffect, useContext } from 'react';
import { Form, Modal, Button } from 'react-bootstrap';

const BoothPopup = ({buttonClass, buttonText, iconSrc, flag}) => {


    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
   
   



    const handleModal = () => {
        setShow(!show)
        setTimeout(() => {
            // Refresh selectpicker after modal is rendered
            window.$('.header-state-selectpicker').selectpicker('refresh');
            window.$('.header-fleet-selectpicker').selectpicker('refresh');
        }, 0);
    }
    const handleClose = () => {
        setShow(false)
    }



  return (
    <div>

    <a className={buttonClass} onClick={handleModal} style={{ cursor: "pointer" }}>
    {buttonText} {iconSrc && <img src={iconSrc} alt="Join Waitlist icon" />}
    </a>



   {/* modal content */}
    <Modal id="waitlist" className='joinlist'  show={show} onHide={handleClose} centered>
        <div className="map-modal">
        <Modal.Header closeButton>
            <Modal.Title>Let’s connect at our booth!</Modal.Title>
        </Modal.Header>
    
              <div className='booth-image'>
              <a href="/rentid.io/"> <img src="img/mapimg.webp" alt="map" /></a>
                {/* <div className='botth-link'><a href="/rentid.io/">www.rentid.io</a></div> */}
              </div>
           <div className='booth-btn'>
            <Button onClick={handleClose}>Close</Button>
            <button className='map_down'>Download map image</button>
            </div>
            </div>
            </Modal>
    </div>
  )
}

export default BoothPopup
